import { type FunctionComponent } from 'react'
import { T as TolgeeT } from '@tolgee/react'

import type { TranslateComponentProps } from './types'

export const T: FunctionComponent<TranslateComponentProps> = props => {
  return <TolgeeT {...props} />
}
